/**
 * Brand color gradients and constants
 */

export const BRAND_GRADIENT_CLASS =
  "bg-[linear-gradient(135deg,rgba(91,127,255,0.95),rgba(42,83,186,0.92))]"
